// Environment configuration loaded from .env (prefixed with REACT_APP_)
const apiUrl = process.env.REACT_APP_API_URL;
const backendIp = process.env.REACT_APP_BACKEND_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;
const backendExt = process.env.REACT_APP_BACKEND_EXTENSION || '';

const formattedExt = backendExt
  ? (backendExt.startsWith('/') ? backendExt : `/${backendExt}`)
  : '';

// Calculate API Base URL strictly from environment variables
export const API_BASE = apiUrl
  ? apiUrl.replace(/\/$/, '')
  : (backendIp && backendPort
      ? `${backendIp.replace(/\/$/, '')}:${backendPort}${formattedExt.replace(/\/$/, '')}`
      : (backendIp
          ? `${backendIp.replace(/\/$/, '')}${formattedExt.replace(/\/$/, '')}`
          : formattedExt.replace(/\/$/, '')));

export const BACKEND_URL = apiUrl
  ? apiUrl
  : (backendIp && backendPort
      ? `${backendIp.replace(/\/$/, '')}:${backendPort}${formattedExt}`
      : (backendIp ? `${backendIp.replace(/\/$/, '')}${formattedExt}` : formattedExt));

